import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyEmployeeMetricsDto, UpsertEmployeeMetricsRequest } from '../../models/api/companyEmployeeMetricsDto';
import { YearlyResource } from '../../models/api/yearlyResource';
import { DefaultCurrencyContext } from '../../models/api/defaultCurrencyContext';

@Injectable({
  providedIn: 'root'
})
export class CompanyEmployeeMetricsService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<YearlyResource<CompanyEmployeeMetricsDto, DefaultCurrencyContext>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<CompanyEmployeeMetricsDto, DefaultCurrencyContext>>(
      `${this.apiUrl}/${companyId}/employee-metrics`,
      { params }
    );
  }

  upsert(companyId: string, request: UpsertEmployeeMetricsRequest): Observable<CompanyEmployeeMetricsDto> {
    return this.http.put<CompanyEmployeeMetricsDto>(`${this.apiUrl}/${companyId}/employee-metrics`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/employee-metrics`, { params });
  }
}
